import React from 'react';
import Link from 'next/link';

interface Props {
  children?: React.ReactNode;
  href: string;
  active?: boolean;
  disabled?: boolean;
  ariaLabel?: string;
}

export const BlogCardPaginationButton = ({
  children,
  href,
  active,
  disabled,
  ariaLabel,
}: Props) => {
  if (disabled) {
    return null;
  }

  return (
    <Link
      href={href}
      aria-label={ariaLabel}
      className={`min-w-[50px] min-h-[50px] text-center content-center py-3 px-4 text-black [&_svg]:fill-black hover:text-white [&_svg]:hover:fill-white hover:bg-primary-shade-green rounded-lg ${active && 'bg-primary-shade-green text-white'}`}
    >
      {children}
    </Link>
  );
};
